import router from "@/router";
import {http} from "@/config/http";
import _ from "lodash";

const namespaced = true;

const getDefaultState = () => {
    return {
        errors: []
    };
};

const state = {
    access_token: localStorage.getItem("access_token") || null,
    agent_code: null,
    user_name: localStorage.getItem("user_name") || null,
    user_id: localStorage.getItem("user_id") || null,
    level: localStorage.getItem("level") || null,
    system_role: localStorage.getItem("system_role") || null,
    user_company: localStorage.getItem("company") || null,
    user_br_code: localStorage.getItem("br_code") || null,
    product_type:localStorage.getItem("product_type") || null,
};

const getters = {
    loggedIn() {
        return localStorage.getItem("access_token") != null;
    },
    systemRole() {
        return localStorage.getItem("system_role");
    }
};

const mutations = {
    setFormErrors(state, data) {
        state.errors = [];
        if (data) {
            state.errors = data.details;
        }
    },

    doLogin(state, response) {
        const token = response.data.access_token;
        if (token) {

            localStorage.setItem("access_token", token);
            localStorage.setItem("user_id", response.data.user_data.user_id);
            localStorage.setItem("user_name", response.data.user_data.user_name);
            localStorage.setItem("level", response.data.user_data.level);
            localStorage.setItem("system_role", response.data.user_data.role_id);
            localStorage.setItem("company", response.data.user_data.company);
            localStorage.setItem("br_code", response.data.user_data.br_code);

            state.access_token = token;
            state.user_id = response.data.user_data.user_id;
            state.user_name = response.data.user_data.user_name;

            state.system_role = response.data.user_data.system_role;
            state.level = response.data.user_data.level;
            state.user_company = response.data.user_data.company;
            state.user_br_code = response.data.user_data.br_code;
            router.push("/proposal/list");
        } else {
            router.push("/login");
        }
    },
    doGuestLogin(state, response) {
        const token = response.data.access_token;
        if (token) {
            localStorage.setItem("access_token", token);
            localStorage.setItem("user_id", response.data.user_data.user_id);
            localStorage.setItem("product_type", response.data.user_data.product_type);
            localStorage.setItem("user_name", response.data.user_data.user_name);
            localStorage.setItem("level", response.data.user_data.level);
            localStorage.setItem("system_role", response.data.user_data.system_role);
            state.access_token = token;
            state.user_id = response.data.user_data.user_id;
            state.user_name = response.data.user_data.user_name;
            state.system_role = response.data.user_data.system_role;
            state.level = response.data.user_data.level;
            state.product_type = response.data.user_data.product_type;
            //router.push("/dashboard");
        } else {
            //router.push("/login");
        }
    },
    doLogout(state) {
        let sys_role = localStorage.getItem("system_role");
        localStorage.removeItem("access_token");
        // localStorage.removeItem("user_permissions");
        localStorage.removeItem("level");
        localStorage.removeItem("system_role");
        localStorage.removeItem("company");
        localStorage.removeItem("br_code");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_id");
        state.access_token = null;
        state.user_name = null;
        state.user_permissions_state = [];
        state.system_role = '';
        state.level = '';
        state.user_company = '';
        state.user_br_code = '';
        state.user_id = '';
        if(sys_role == 4){
            router.push("/proposal/link_expired");
        }else{
            router.push("/login");
        }

    }
};

const actions = {


    async SubmitForgotPassword({commit}, data) {
        let email = data.email;
        let api = true;

        await http
            .post("auth/password/send_reset_link", null, {
                params: {
                    email,
                    api
                }
            })
            .then(response => { 
                if (response.data.error) {
                    commit(
                        "showAlert",
                        {
                            title: "Success!",
                            msg: 'Please check your inbox to find your reset link',
                            type: "success",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                } else {
                    commit(
                        "showAlert",
                        {
                            title: "Success!",
                            msg: 'Please check your inbox to find your reset link',
                            type: "success",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                }

            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Success!",
                        msg: "Oops..something went wrong.",
                        type: "error",
                        position: "centerTop"
                    },
                    {root: true}
                );
            });
    },

    async getGuestToken({commit}, data) {
        return new Promise((resolve, reject) => {
             http
                .post("auth/guest_login", data)
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error.message,
                                type: "error",
                                position: "centerTop"
                            },
                            {root: true}
                        );
                        // commit("doLogout", response);
                    } else {
                        commit("doGuestLogin", response);
                    }
                    resolve(response);
                })
                .catch(error => {
                    //console.log(response.data);
                    commit("doLogout", response);
                });
        });
    },

    async getToken({commit}, data) {
        let user_name = data.user_name;
        let password = data.password;

        await http
            .post("auth/login", data )
            .then(response => {
                if (response.data.error) {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: response.data.error.message,
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                    // commit("doLogout", response);
                } else {
                    commit("doLogin", response);
                }

            })
            .catch(error => {
                //console.log(response.data);
                commit("doLogout", response);
            });
    },

    async destoryToken({commit}) {
        await http
            .post("auth/logout", null, {})
            .then(response => {
                if (response.data.status == "true") {
                    //console.log(error);
                    commit("doLogout");
                } else {
                    // console.log(error);
                    commit("doLogout");
                }
            })
            .catch(error => {
                //console.log(error);
                commit("doLogout");
            });
    }

};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
